import React, { useEffect } from "react";
import Header from "../../components/Header";
import Welcome from "../../components/Welcome";
import "./style.scss";
import { useLocation, useNavigate } from "react-router";
import { applyLayoutStylse, moveToTop } from "../../helpers/DomHelper";
import apiOpen from "../../api/open";
import { updateAppIfNeeded } from "../../helpers/orderHelper";

const MainPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    window._navigateTo = (to: string) => {
        navigate(to)
    }

    useEffect(() => {
        checkLayoutStyles();
    }, []);

    useEffect(() => {
        updateAppIfNeeded();

        if (!localStorage.getItem("host") || !localStorage.getItem("cashRegisterId"))
            navigate("/settings");

        moveToTop();
    }, [location]);

    const checkLayoutStyles = async () => {
        const styles = await apiOpen.getStyles();
        if (styles)
            applyLayoutStylse(styles);

        setTimeout(() => {
            checkLayoutStyles();
        }, 3600000);
    }

    return <div className="MainPage">
        <Header />
        <Welcome />
    </div>
}

export default MainPage;